import { render } from "./App.vue?vue&type=template&id=a951cf2e"
import script from "./App.vue?vue&type=script&setuplang=ts&lang=js"
export * from "./App.vue?vue&type=script&setuplang=ts&lang=js"

import "./App.vue?vue&type=style&index=0&id=a951cf2e&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.3.1_vue@3.3.11_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__